import React from "react";
import { useSelector } from "react-redux";
import Logo from "../assets/images/logo.png";

const Navbar = ({ setRoute }) => {
  const carts = useSelector((state) => state.carts.cartItems);

  const totalValue = carts.reduce((a, c) => a + c.quantity, 0);

  return (
    <nav className="bg-[#171C2A] py-4">
      <div className="navBar">
        <a href="index.html">
          <img src={Logo} alt="LWS" className="max-w-[140px]" />
        </a>

        <div className="flex gap-4">
          <a
            href="#home"
            className="navHome"
            id="lws-home"
            onClick={(e) => {
              e.preventDefault();
              setRoute("home");
            }}
          >
            Home
          </a>
          <a
            href="cart.html"
            className="navCart"
            id="lws-cart"
            onClick={(e) => {
              e.preventDefault();
              setRoute("cart");
            }}
          >
            <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
            <span id="lws-totalCart">{totalValue}</span>
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
